module.exports = __webpack_public_path__ + "static/media/centro_medio_2(1).e9abf5e3.jpg";